"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROVIDED_TAG = exports.IMPORTED_TAG = exports.MODULE_METADATA_KEYS = exports.MODULE_IS_BINDED_KEY = exports.IS_MODULE_KEY = void 0;
exports.IS_MODULE_KEY = "isModule";
exports.MODULE_IS_BINDED_KEY = "isBinded";
exports.MODULE_METADATA_KEYS = ["id", "isModule", "isBinded", "container", "imports", "providers", "globalProviders", "exports"];
exports.IMPORTED_TAG = "exports";
exports.PROVIDED_TAG = "provided";
